import { useMemo } from 'react';

import {
  CalculatedBuildFailureRate,
  BuildFailureRate,
} from '../components/list-sidebar/types';

import {
  usePipelinesTimeseries,
  PipelinesTimeseries,
  generateEmptyDataItem,
} from './use-pipelines-timeseries';
import {
  usePipelinesTimeseriesAverage,
  PipelinesTimeseriesAverage,
} from './use-pipelines-timeseries-average';

export type BuildFailureRateData = PipelinesTimeseriesAverage &
  PipelinesTimeseries & {
    data: CalculatedBuildFailureRate[];
  };

const BUILD_FAILURE_RATE_ENDPOINT = '/build/failure-rate';

export const getDataWithCalculatedRate = (
  data: BuildFailureRate[]
): CalculatedBuildFailureRate[] => {
  return data.map(d => {
    if (!d.data) return generateEmptyDataItem(d);

    const { successful, failed } = d.data;
    const total = successful + failed;
    if (!total) return generateEmptyDataItem(d);

    return {
      ...d,
      data: {
        ...d.data,
        totalBuilds: total,
        failureRate: failed / total,
        successRate: successful / total,
      },
    };
  });
};

export function useBuildFailureRate(
  repositoryUuid?: string | null
): BuildFailureRateData {
  const { data, isLoading, error } = usePipelinesTimeseries(
    BUILD_FAILURE_RATE_ENDPOINT,
    repositoryUuid
  );

  const { dataWithCalculatedRate } = useMemo(() => {
    return {
      dataWithCalculatedRate: getDataWithCalculatedRate(data),
    };
  }, [data]);

  return {
    data: dataWithCalculatedRate,
    isLoading,
    error,
    ...usePipelinesTimeseriesAverage(
      dataWithCalculatedRate,
      'successRate',
      true
    ),
  };
}
